<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" *ngIf="!oneLine">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
    <a href="https://itunes.apple.com/us/app/provalt-equarrissage/id1239830269?l=fr&ls=1&mt=8">
      <img src="../../../assets/img/appstore.png" alt="App Store" style="height: 55px; max-width: 100%;"/>
    </a>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <a href="https://play.google.com/store/apps/details?id=fr.monnard.apps.android.equarrissage">
      <img src="../../../assets/img/googleplay.png" alt="Google Play" style="height: 55px; max-width: 100%;"/>
    </a>
  </div>
</div>

<div class="row" *ngIf="oneLine">
  <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
    <a href="https://itunes.apple.com/us/app/provalt-equarrissage/id1239830269?l=fr&ls=1&mt=8">
      <img src="../../../assets/img/appstore.png" alt="App Store" style="height: 55px; max-width: 100%;"/>
    </a>
  </div>

  <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
    <a href="https://play.google.com/store/apps/details?id=fr.monnard.apps.android.equarrissage">
      <img src="../../../assets/img/googleplay.png" alt="Google Play" style="height: 55px; max-width: 100%;"/>
    </a>
  </div>
</div>
